import product1img1 from './img/shop/shop1/ki3.jpg'
import product2img1 from './img/shop/shop1/i3.jpg'
import product3img1 from './img/shop/shop1/k3.jpg'
import product4img1 from './img/shop/shop1/le1.jpeg'

    export const TRENDING = [
        {   
            id: 6,
            amount: 1,
            route: 'product6',
            name: "AniStore",
            title: "Killua Collectible Figurines",
            price: 59.99,
            image1: product1img1,
        },
        {   
            id: 3,
            amount: 1,
            route: 'product3',
            name: "AniStore",
            title: "Itachi Collectible Figurines",
            price: 59.99,
            description: 'our Figurines are a collectible, three-dimensional representation of a character from an Anime or Manga series. These figurines are meticulously designed and crafted to capture the appearance, costume, and distinct features of the characters. They are often made from materials like PVC (polyvinyl chloride) and come in various sizes, ranging from a few inches to over a foot in height. Our figurines are sought after by fans and collectors alike, allowing them to bring a piece of their favorite anime world into their physical space. Whether posed in iconic stances, dynamic action poses, or displaying signature techniques, these figurines celebrate the vibrant and adventurous world of Anime and Manga series',
            image1: product2img1,
        },
        {   
            id: 4,
            amount: 1,
            route: 'product4',
            name: "AniStore",
            title: "Zenitsu Collectible Figurines",
            price: 59.99,
            description: 'our Figurines are a collectible, three-dimensional representation of a character from an Anime or Manga series. These figurines are meticulously designed and crafted to capture the appearance, costume, and distinct features of the characters. They are often made from materials like PVC (polyvinyl chloride) and come in various sizes, ranging from a few inches to over a foot in height. Our figurines are sought after by fans and collectors alike, allowing them to bring a piece of their favorite anime world into their physical space. Whether posed in iconic stances, dynamic action poses, or displaying signature techniques, these figurines celebrate the vibrant and adventurous world of Anime and Manga series',
            image1: product3img1,
        },
        {
            id: 2,
            amount: 1,
            route: 'product2',
            name: "AniStore",
            title: "Rock lee Collectible Figurines",
            price: 59.99,
            description: 'our Figurines are a collectible, three-dimensional representation of a character from an Anime or Manga series. These figurines are meticulously designed and crafted to capture the appearance, costume, and distinct features of the characters. They are often made from materials like PVC (polyvinyl chloride) and come in various sizes, ranging from a few inches to over a foot in height. Our figurines are sought after by fans and collectors alike, allowing them to bring a piece of their favorite anime world into their physical space. Whether posed in iconic stances, dynamic action poses, or displaying signature techniques, these figurines celebrate the vibrant and adventurous world of Anime and Manga series',
            image1: product4img1,
        }
    ]